import { z } from 'zod'
import { FlightDeckEnvSchema } from './env.schema'

/**
 * flight-deck-ui's settings, fetched from the server that served this bundle. Embedded in premier-ui,
 * that is Flight Deck's server. The top-level await makes every importer wait for the settings, and a
 * failed fetch fails those imports.
 */

/** Set by rspack to the URL this bundle was served from (`output.publicPath: 'auto'`). */
declare const __webpack_public_path__: string

const RUNTIME_CONFIG_FILE = 'runtime-config.json'

async function fetchConfig() {
  const base = new URL(__webpack_public_path__ || '/', window.location.href)
  const res = await fetch(new URL(RUNTIME_CONFIG_FILE, base), { cache: 'no-store' })
  if (!res.ok) {
    throw new Error(`flight-deck-ui could not load ${RUNTIME_CONFIG_FILE}: HTTP ${res.status}`)
  }

  // The same rule the UI server checked the file with before serving it.
  const parsed = z.object(FlightDeckEnvSchema).safeParse(await res.json())
  if (!parsed.success) {
    throw new Error(
      `flight-deck-ui's ${RUNTIME_CONFIG_FILE} is missing or invalid: ${JSON.stringify(z.flattenError(parsed.error).fieldErrors)}`,
    )
  }
  return parsed.data
}

export const config = await fetchConfig()
